import { useCallback, useState } from 'react';

type SaveColumnOrder = (
  newOrder: string[],
  options: { onError: () => void; onSuccess: () => void }
) => void;

export function useColumnOrderPreference(
  savedOrder: string[] | null | undefined,
  saveOrder: SaveColumnOrder
) {
  const [pendingOrder, setPendingOrder] = useState<string[] | null | undefined>(
    undefined
  );
  const order =
    pendingOrder !== undefined ? pendingOrder : (savedOrder ?? null);

  const handleColumnReorderEnd = useCallback(
    (newOrder: string[]) => {
      const previousOrder = order;
      setPendingOrder(newOrder);
      saveOrder(newOrder, {
        onError: () => setPendingOrder(previousOrder),
        onSuccess: () => setPendingOrder(undefined),
      });
    },
    [order, saveOrder]
  );

  return { order, handleColumnReorderEnd };
}
